import React from "react";
import Select from "react-select";
import {
  mergeReactSelectStyles,
  reactSelectBaseStyles,
} from "./reactSelectTheme";

const SelectField = ({
  labelName,
  name,
  uni,
  onChange,
  value,
  touched,
  error,
  menuPortalTarget,
  menuPosition,
  options,
  selectStyles,
}) => {
  const mergedStyles = mergeReactSelectStyles(
    reactSelectBaseStyles,
    selectStyles
  );

  return (
    <div className="flex w-full">
      <div className="col-span-1 flex w-full flex-col">
        <label
          className="mb-1.5 block text-sm font-medium text-secondary"
          htmlFor={uni}
        >
          {labelName}
        </label>
        <Select
          className="w-full"
          classNamePrefix="bill-select"
          options={options?.map((item) => ({
            value: item,
            label: item.name,
          }))}
          name={name}
          menuPortalTarget={menuPortalTarget}
          menuPosition={menuPosition}
          styles={mergedStyles}
          onChange={onChange}
          value={value}
        />
      </div>
      {touched && error && (
        <p className="mt-1 text-sm font-medium text-red-600">{error}</p>
      )}
    </div>
  );
};

export default SelectField;
